(() => {
  const initSummaryControls = () => {
    document.querySelectorAll('.fizo-cart-summary__panel').forEach((panel) => {
      if (panel.dataset.fizoCartControlsBound === 'true') return;
      panel.dataset.fizoCartControlsBound = 'true';

      const promoTrigger = panel.querySelector('.fizo-cart-summary__promo-trigger');
      const promoForm = panel.querySelector('.fizo-cart-summary__promo-form');
      const getAppliedDiscountCodes = () => Array.from(panel.querySelectorAll('.fizo-cart-summary__discount-remove'))
        .map((item) => item.dataset.discountCode)
        .filter(Boolean);
      const updateDiscountCodes = async (discountCodes) => {
        const cartRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${cartRoot}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: discountCodes.join(',') }),
        });

        if (!response.ok) throw new Error(`Discount update failed: ${response.status}`);
        window.location.reload();
      };

      promoTrigger?.addEventListener('click', () => {
        const expanded = promoTrigger.getAttribute('aria-expanded') !== 'true';
        promoTrigger.setAttribute('aria-expanded', String(expanded));
        promoForm.hidden = !expanded;
        if (expanded) promoForm.querySelector('input')?.focus();
      });

      promoForm?.addEventListener('submit', async (event) => {
        event.preventDefault();
        const input = promoForm.querySelector('input');
        const code = input?.value.trim();
        if (!code) {
          input?.focus();
          return;
        }

        const appliedCodes = getAppliedDiscountCodes();
        const codeExists = appliedCodes.some((appliedCode) => appliedCode.toLowerCase() === code.toLowerCase());

        try {
          await updateDiscountCodes(codeExists ? appliedCodes : [...appliedCodes, code]);
        } catch (error) {
          console.error(error);
          input?.focus();
        }
      });

      panel.querySelectorAll('.fizo-cart-summary__discount-remove').forEach((button) => {
        button.addEventListener('click', async () => {
          if (button.dataset.loading === 'true') return;

          button.dataset.loading = 'true';
          button.disabled = true;
          const removedCode = button.dataset.discountCode;
          const remainingCodes = getAppliedDiscountCodes()
            .filter((code) => code && code !== removedCode);

          try {
            await updateDiscountCodes(remainingCodes);
          } catch (error) {
            console.error(error);
            button.dataset.loading = 'false';
            button.disabled = false;
          }
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initSummaryControls);
  document.addEventListener('shopify:section:load', initSummaryControls);
})();
